import React, { Component, Fragment } from 'react'
import { connect } from "react-redux"
import SchoolInformation from "./SchoolInformation"
import { SchoolInformationActions } from "../../../../store"
import spinner from "../../../ui/icons/spinner.gif";
import { ValidationUtil } from './index'
import lodashUtil from 'lodash';
import { toast } from 'react-toastify'
import * as StringReplacer from '../../../../i18n/StringReplacer'
import { MuiGrid } from '../../../ui';
import {saveSchoolConcurrently} from '../../../../utils/ConcurrentSchoolSaveUtil';

import theme from '../../../../assests/theme'
class EditSchoolInformationContainer extends Component {
  constructor(props) {
    super(props)
    let isEditNotAllowed = false
    if (props.activeProfileType != "OWNER") {
      isEditNotAllowed = true
    }
    this.state = {
      previousProps: JSON.parse(JSON.stringify(props.activeSchool)),
      activeSchool: props.activeSchool,
      errors: [""],
      error: {},
      schoolName: props.activeSchool.name,
      isEditNotAllowed: isEditNotAllowed,
      showDialog: false
    };
  }
  componentDidMount() {
    let schoolName = this.props.activeSchool.name
    this.setState({
      ...this.props.activeSchool,
      schoolName: schoolName
    })
  }
  componentWillReceiveProps(nextProps, prevState) {

    let isEditNotAllowed = true
    if (nextProps.activeProfileType !== prevState.activeProfileType) {
      if (nextProps.activeProfileType != "OWNER") {

        this.setState({
          isEditNotAllowed: true
        })
      } else {
        this.setState({
          isEditNotAllowed: false
        })
      }
    }
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let isEditNotAllowed = true
    if (prevState.activeSchool !== nextProps.activeSchool) {
      if (nextProps.activeProfileType != "OWNER") {
        isEditNotAllowed = true
      } else {
        isEditNotAllowed = false
      }
      return {
        activeSchool: nextProps.activeSchool,
        isEditNotAllowed: isEditNotAllowed,
        errors: [""]
      };
    }
    // Return null to indicate no change to state.
    return null;
  }


  handleChange = (name, event) => {

    let obj = this.state.activeSchool;
    obj[name] = event.target.value
    this.setState({
      activeSchool: obj,
      showDialog: true
    })
  }

  handleChangeOfAddress = (name, event) => {
    let tempAddress = this.state.activeSchool.address;
    tempAddress[name] = event.target.value;
    let tempActiveSchool = this.state.activeSchool;
    tempActiveSchool.address = tempAddress
    this.setState({
      activeSchool: tempActiveSchool,
      showDialog: true
    })
  }

  handleChangeOfPhone = (event, data, name) => {

    let tempActiveSchool = this.state.activeSchool;
    tempActiveSchool[name] = event
    tempActiveSchool[name + "Val"] = event.replace(/[^0-9]+/g, '').slice(data.dialCode.length)
    this.setState({
      activeSchool: tempActiveSchool,
      showDialog: true
    })
  }

  componentWillUnmount() {
    if (this.state.showDialog) {
      this.beforeUnload()
    }
  }

  undoChanges = () => {
    if (this.state.previousProps.name !== undefined) {
      let previousProps = this.state.previousProps
      this.props.activeSchool.name = previousProps.name
      this.props.activeSchool.primaryPhoneNumber = previousProps.primaryPhoneNumber
      this.props.activeSchool.secondaryPhoneNumber = previousProps.secondaryPhoneNumber
      this.props.activeSchool.address.line1 = previousProps.address.line1
      this.props.activeSchool.email = previousProps.email
      this.props.activeSchool.address.city = previousProps.address.city
      this.props.activeSchool.address.pincode = previousProps.address.pincode
      this.props.activeSchool.website = previousProps.website
      this.props.activeSchool.address.country = previousProps.address.country
    }
    this.setState({
      showDialog: false
    })
  }
  beforeUnload = async () => {
    const i18n = this.props.i18n
    var flag = window.confirm(i18n.schoolInformationTab.msgForUnsavedChangesInTab);
    if (flag) {
      await this.onClickOfSave()
    }
    else {
      await this.undoChanges()
    }
  }

  onClickOfSave = async (showDialog) => {
    const i18n = this.props.i18n
    let activeSchool = this.state.activeSchool;
    let validation = ValidationUtil.validateForm(activeSchool, i18n);
    let primaryPhoneNumberValidation = ValidationUtil.phoneNumberValidation(i18n, activeSchool.primaryPhoneNumberVal, true);
    let secondaryPhoneNumberValidation = ValidationUtil.phoneNumberValidation(i18n, activeSchool.secondaryPhoneNumberVal);
    let profiles = this.props.userInformation.profiles
    let uniqueSchoolNameFlag = await this.uniqueSchoolNameValidationWhenEditing(activeSchool, profiles);
    if (validation.formValid
      && uniqueSchoolNameFlag
      && primaryPhoneNumberValidation.validation
      && secondaryPhoneNumberValidation.validation) {
      /* let result = await this.props.editSchoolInformation(this.props.userInformation._id, this.state.activeSchool._id, this.state.activeSchool)
      if(result && result.status === false){
        console.log(result);
        toast("Save Failed with Error - "+ result.result)
        this.setState({
          error: result.result,
          activeSchool: activeSchool,
        })
      } else{
        toast(i18n.toastMsgs.schoolInformationSavedSuccessfully)
        this.setState({
          error: {},
        })
      }  */
     
      // let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
        // this.props.userInformation._id, this.state.activeSchool._id, this.state.activeSchool,
        // i18n.toastMsgs.schoolInformationSavedSuccessfully);
        let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
          this.props.userInformation._id,
          this.state.activeSchool._id,
          this.state.activeSchool,
          i18n.toastMsgs.schoolInformationSavedSuccessfully);
        if(result.success){
          this.setState({
            error: {},
            activeSchool:result.updatedSchool
          })
        }else{
          this.setState({
            error: result.result,
            activeSchool: activeSchool,
          })
        }
        
    }
    this.setState({
      activeSchool: activeSchool,
      errors: validation.errors,
      showDialog: showDialog,
      primaryPhoneNumberError: primaryPhoneNumberValidation.phoneNumberError,
      secondaryPhoneNumberError: secondaryPhoneNumberValidation.phoneNumberError
    });
  }

  uniqueSchoolNameValidationWhenEditing = (activeSchool, profiles) => {
    const i18n = this.props.i18n
    let currentSchoolName = activeSchool.name;
    let schooId = activeSchool._id
    let schoolList = lodashUtil.find(profiles, ["profileType", "OWNER"]);
    if (this.state.schoolName !== activeSchool.name) {
      if (schoolList !== undefined) {
        let schools = schoolList.schools;
        let currentSchoolIndex = lodashUtil.findIndex(schools, ["_id", schooId]);
        if (currentSchoolIndex !== -1) {
          for (let i = 0; i < schools.length; i++) {
            if (i === currentSchoolIndex) {
              continue
            }
            let schoolName = schools[i].name
            if (currentSchoolName.toLowerCase() === schoolName.toLowerCase()) {
              let errorMessage_UniqueSchoolName = StringReplacer.getFormatedMessage(i18n.schoolInformationTab.UniqueSchoolName,
                {
                  schoolName: currentSchoolName,
                })
              this.state.error.name = errorMessage_UniqueSchoolName
              return false;
            }
          }
        }
        schools[currentSchoolIndex].name = currentSchoolName;
      }
    }
    return true
  }

  showContextualHelp = (props, event) => {
    let content = props.contextualHelp["schoolInformation"];
    if (content !== undefined) {
      props.toggleDrawer("right", true, content)(event)
    }
  }

  render() {
    if (this.props.activeSchool._id == undefined || this.props.activeSchool._id == null || this.props.activeSchool._id == 0) {
      return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' ><img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
    }
    if (this.props.updateSchoolinformationInProgress == true) {
      return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' ><img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
    }
    else {
      return <Fragment> {this.props.updateSchoolinformationInProgress == true ? <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' ><img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
        : <SchoolInformation
          {...this.state}
          {...this.props}
          onClickOfSave={this.onClickOfSave}
          handleChange={this.handleChange}
          handleChangeOfAddress={this.handleChangeOfAddress}
          handleChangeOfPhone={this.handleChangeOfPhone}
          showContextualHelp={this.showContextualHelp}
        />}</Fragment>
    }



  }
}
const mapDispatchToProps = (dispatch) => ({
  // todo : edit school put call
  editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
  updatedSchoolMaster: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.updatedSchoolMaster(ownerId, schoolId, data))
}
)

const mapStateToProps = (state) => {

  return {
    userInformation: state.userProfile.userInformation,
    activeSchool: state.schoolInformation.activeSchool,
    activeProfileType: state.userProfile.activeProfileType,
    updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSchoolInformationContainer);